import { isDance25Model } from './videoModelCapabilities'

type VideoModelItem = {
    model_key?: string
    model_version_list?: VideoModelItem[]
}

export type Dance25ModelSelection = {
    familyKey: string
    versionKey: string
}

const normalizeModelKey = (modelKey?: string) =>
    String(modelKey || '')
        .trim()
        .toLowerCase()
        .replace(/[\s._-]+/g, '')

const getDance25Keys = (modelKey?: string) => {
    const normalized = normalizeModelKey(modelKey)
    if (normalized === 'seedance25') {
        return new Set(['seedance25'])
    }
    if (normalized === 'werydance25') {
        return new Set(['werydance25'])
    }
    return new Set<string>()
}

/**
 * 将 2.5 的版本键或分类键解析为当前设置页所需的父模型键和真实版本键。
 * 仅处理 2.5，避免放宽既有模型的严格匹配行为。
 */
export const resolveDance25ModelSelection = (
    models: VideoModelItem[],
    incomingKey?: string
): Dance25ModelSelection | null => {
    if (!isDance25Model(incomingKey) || !Array.isArray(models)) return null

    const candidates = getDance25Keys(incomingKey)
    for (const model of models) {
        const versions = Array.isArray(model.model_version_list)
            ? model.model_version_list
            : []
        const matchedVersion = versions.find(version =>
            candidates.has(normalizeModelKey(version.model_key))
        )
        const familyMatches = candidates.has(normalizeModelKey(model.model_key))

        if (!familyMatches && !matchedVersion) continue

        const familyKey = String(model.model_key || '')
        const versionKey = String(
            matchedVersion?.model_key || versions[0]?.model_key || model.model_key || ''
        )
        if (familyKey && versionKey) return { familyKey, versionKey }
    }

    return null
}
